<template>
  <div class="card mb-3">
    <div class="card-header" :id="'heading' + index">
      <div class="mb-0">
        <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse' + index" aria-expanded="true"
                :aria-controls="'collapse' + index">Cyber Liability Coverage Insurance</button>
        <button class="btn mt-1 font-size-small text-color-grey float-right">{{ dateCreated }}</button>
      </div>
    </div>
    <div :id="'collapse' + index" class="collapse" :aria-labelledby="'headingFour' + index" data-parent="#accordion">
      <div class="card-body d-md-flex flex-md-wrap">
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Company Name : </span>
          <span>{{ data.companyname }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Applicant Name : </span>
          <span>{{ data.applicantname }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Email : </span>
          <span>{{ data.email }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Company Type : </span>
          <span>{{ data.companytype }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Address : </span>
          <span>{{ data.address }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Title : </span>
          <span>{{ data.title }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Phone Number : </span>
          <span>{{ data.phonenumber }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Number of Years Established : </span>
          <span>{{ data.yearsestablished }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Number of Employees : </span>
          <span>{{ data.numberemployees }}</span>
        </div>
        <div class="w-md-30 ml-3">
          <span class="font-weight-bold text-color-grey">Website : </span>
          <span>{{ data.website }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsuranceViewCyber',
  // Load props received from parent component to display insurance data
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    }
  },
  // convert date to a string using local settings
  data () {
    return {
      dateCreated: null
    }
  },
  created () {
    let date = new Date(this.data.created_on)
    this.dateCreated = date.toLocaleString()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/insurances/views/InsuranceViewCyber.vue